<svelte:options tag='swc-star' immutable={true} />

<script>
</script>

<style>
</style>

<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M7.46553 12.3967C7.20268 12.2603 6.8899 12.2603 6.62705 12.3967L3.76466 13.8823C3.09628 14.2291 2.31983 13.6606 2.44873 12.9186L2.98964 9.8054C3.04139 9.50754 2.94186 9.20342 2.724 8.99379L0.441343 6.79732C-0.104735 6.27187 0.193015 5.34821 0.943167 5.24061L4.11857 4.78512C4.41403 4.74274 4.66992 4.55818 4.8034 4.29121L6.23224 1.43325C6.56763 0.762399 7.52495 0.762399 7.86034 1.43325L9.28918 4.29121C9.42265 4.55818 9.67855 4.74274 9.97401 4.78512L13.1494 5.24061C13.8996 5.34821 14.1973 6.27186 13.6512 6.79732L11.3686 8.99379C11.1507 9.20342 11.0512 9.50754 11.1029 9.8054L11.6438 12.9186C11.7728 13.6606 10.9963 14.2291 10.3279 13.8823L7.46553 12.3967Z" fill="#FADF4B"/>
</svg>
